module.exports = __webpack_public_path__ + "static/media/tachometer-fast.6d682eb2.svg";